import { FirebaseAuthErrorCode } from '@griply/types';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

// Expired and already-used both mean the same to the user: request a new link.
const DEAD_LINK_CODES: string[] = [
  FirebaseAuthErrorCode.InvalidActionCode,
  FirebaseAuthErrorCode.ExpiredActionCode,
];

export const mapResetPasswordError = (
  code: string,
): ResetPasswordErrorTypes => {
  if (DEAD_LINK_CODES.includes(code)) {
    return ResetPasswordErrorTypes.InvalidCode;
  }

  if (code === FirebaseAuthErrorCode.WeakPassword) {
    return ResetPasswordErrorTypes.WeakPassword;
  }

  return ResetPasswordErrorTypes.Unknown;
};
